module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@3x-fae83735e7ef042fdac47bd2745d4374.webp";